import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('Configuration')
export class Configuration {

  @JsonProperty('name', String)
  name: string = '';

  @JsonProperty('description', String)
  description: string = '';

  @JsonProperty('value_text', String)
  valueText: string = '';

  @JsonProperty('value_integer', Number)
  valueInteger: number = 0;
}
